import { z, ZodType } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';
import { EntityWithTitle, entityWithTitleSchema } from './entity-with-title';

export const PLAYER_TRANSACTION_TYPE = {
	win: 'win',
	lose: 'lose',
	refund: 'refund',
	deposit: 'deposit',
	withdrawal: 'withdrawal',
	voucherActivated: 'voucher-activated',
	voucherCompleted: 'voucher-completed',
	voucherCanceled: 'voucher-canceled',
	jackpot: 'jackpot',
	bonus: 'bonus',
} as const satisfies Record<string, string>;

export type PlayerTransactionType =
	(typeof PLAYER_TRANSACTION_TYPE)[keyof typeof PLAYER_TRANSACTION_TYPE];

export type PlayerTransaction = {
	id: string;
	date: string;
	account: EntityWithName;
	cashdesk: EntityWithName;
	device: EntityWithName;
	player: EntityWithName;
	game: EntityWithTitle;
	cashier: EntityWithName | null;
	currency: string;
	amount: number;
	type: string;
	balanceBefore: number | null;
	balanceAfter: number | null;
};

export const playerTransactionSchema: ZodType<PlayerTransaction> = z.object({
	id: z.string(),
	date: z.string(),
	account: entityWithNameSchema,
	cashdesk: entityWithNameSchema,
	device: entityWithNameSchema,
	player: entityWithNameSchema,
	game: entityWithTitleSchema,
	cashier: entityWithNameSchema.nullable(),
	currency: z.string(),
	amount: z.number(),
	type: z.string(),
	balanceBefore: z.number().nullable(),
	balanceAfter: z.number().nullable(),
});
